<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
  
      <div  class="container" >
        <div class="d-flex justify-content mt-2" v-if="role==1">
          <div :class="user_type==1?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" @click="change_user_type(1)">客户</div>
          <div :class="user_type==2?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" @click="change_user_type(2)">管理员和渠道</div>
        </div>
        
        
        <div v-if="users.length==0 && !isLoading" class="title mt-2">暂无账号</div>
        <div  v-else class="mt-2">
          
          <div v-for="(user,index) in users" :key="index">
            <div class="mt-2 d-flex justify-content-between secondColor">
              <div>
                <div>用户ID:{{ user.objectId }}</div> <div>注册时间：{{ localDatetime(user.createdDate) }}</div>
              </div>

               <div>
                     <router-link :to="`/admin/newAccount/${user.objectId}`">
                      新增账号
                  </router-link>
                     <router-link :to="`/admin/usernotes/${user.objectId }/undefined`" class="ml-1">笔记管理</router-link>
                  </div>
            </div>
            <div v-if="(user.groups!=undefined&& user.groups.length>0)">
              <template v-for="(group,g_index) in user.groups" :key="g_index">
                <div class="d-flex justify-content-between align-items-center mt-2" v-if="group.name!='' &&group.accounts.length>0">
                  <div>{{ group.name }}</div>
                  <div>
                     <router-link :to="`/admin/usernotes/${user.objectId }/${group.objectId}`" class="ml-1">笔记管理</router-link>
                  </div>
                  
                </div>
                
                <table v-if="group.accounts.length>0">
                <tr class="table_title">
                    <th>ID</th>
                    <th>账号</th>
                    <th>手机号</th>
                    <th>粉丝数</th>
                   
                    <th>选题</th>
                
                    <th>状态</th>
                  <th>有效期</th>
                    <th>操作</th>
                <th v-if="role==1">cookie</th>
                   
                    <th v-if="role==1"></th>
                   
                    <th v-if="role==1">选题重置</th>
                </tr>
                
                <template v-for="(account,ac_index) in group.accounts" :key="ac_index">
                  <tr>
                    <td >
                      <div>{{account.objectId}}</div>
                      
                      <div><button  :class="account.setAuth==true?'normalNav selectedNav':'normalNav'"  @click="setAuth(account)">配置权限</button></div>
                    </td>
                    <td>
                    <div v-if="account.user_info==undefined">新账号</div>
                    <div v-else class="d-flex justify-content">
                        <div v-if="account.user_info.imageb!=undefined">
                        <img :src="account.user_info.imageb" class="account_icon">
                        </div>
                        <div class="d-flex flex-row align-items-center ml-1">
                            <div>{{account.user_info.nickname}}</div>
                        </div>
                    </div>
                    <div v-if="account.is_template!=undefined && account.is_template==true" class="template">模版账号</div>
                    <div v-if="account.is_tencent==true" class="tencent">视频号</div>
                    </td>
                    <td>{{account.phone_no}}</td>
                    <td>
                      <div v-if="account.fans!=undefined">{{ account.fans }}</div>
                    </td>
                    <td>
                    <div v-if="account.title!=undefined">
                        {{ account.title.user_input }}
                    </div>
                    
                    <div v-if="account.title!=undefined">
                      <span v-if="account.title.count_type==undefined || account.title.count_type=='day'">1天</span>
                       <span v-if="account.title.count_type=='week'">1周</span>
                       <span v-if="account.title.count_type=='month'">1月</span>
                      <span>{{ account.title.day_count }}篇</span>
                    </div>
                    
                    </td>
                    
                    <td>  
                     
                  <div class="col invalidText" v-if="account.is_tencent!=true">
                      <span v-if="account.valid==false">无效用户</span>
                      <div v-else>
                        <span v-if="account.fenghao==true">封号</span>
                        <span v-if="(user.role<1 || user.role==undefined)&&(account.auth==undefined || account.auth.expired)">会员过期</span>
                        <div v-else>
                          <span v-if="account.cookies==undefined || account.cookies.need_login ||account.cookies.status==0 ">授权过期</span>
                        </div>
                      </div>              
                 
           
           
          </div>
                    </td>
                    <td>   <span v-if="user.role>0">永久</span>
                      
                     
         
            <div v-else>
              <div v-if="account.auth!=undefined">
            <div class="right-gap" v-if="account.auth!=undefined">{{ account.auth.product_name }}</div>
            <div :class="account.auth.expired?'expired':''">{{ formatDate(account.auth.start_date) }}至{{ formatDate(account.auth.end_date) }}</div>
          </div>
           </div></td>
                    <td>
                    <div class="d-flex justify-content-center">
                  
                        <router-link :to="`/qr/${account.objectId}`"> <img class="operationIcon" src="../assets/icon-login.svg" alt="授权" title="授权"></router-link>
                     
                        <router-link :to="`/index/user/newAccount/${account.objectId}`"><img class="operationIcon" src="../assets/icon-setting.png" alt="账号管理" title="账号管理"></router-link>
                        <router-link :to="`/admin/note/${account.objectId}`"><img class="operationIcon" src="../assets/icon-file.png" alt="帖子" title="帖子"></router-link>


                       
                    </div>
                    
                    </td>
                
                   <td v-if="role==1 " >
                      <div class="backBtn" @click="setCookie(account.objectId)">配置Cookie</div>
                    </td>
                    <td v-if="role==1" >
                      <div class="d-flex justify-content">
                          <button class="backBtn" @click="deleteAccount(index, account.objectId,ac_index,g_index)">删除</button>
                    
                          <button class="backBtn" @click="validAccount(account.objectId,index,ac_index,g_index)" v-if="account.valid==false">激活</button>
                          <button class="backBtn" @click="validAccount(account.objectId,index,ac_index,g_index)" v-else>下线</button>
                      </div>
                     
                    <div class="d-flex justify-content mt-1">

                    
                        <button class="backBtn" @click="fenghaoAccount(account.objectId,index,ac_index,g_index)" v-if="account.fenghao==true">解封</button>
                        <button class="backBtn" @click="fenghaoAccount(account.objectId,index,ac_index,g_index)" v-else>封号</button>
                    
                        <button class="backBtn" @click="templateAccount(account.objectId,index,ac_index,g_index)" v-if="account.is_template==true">非模板</button>
                        <button class="backBtn" @click="templateAccount(account.objectId,index,ac_index,g_index)" v-else>模板</button>
                      </div>
                    </td>
                    <td v-if="role==1">
                      <div class="backBtn" @click="resetAccount(account.objectId)">选题重置</div>
                    </td>
                </tr>
                <tr v-if="role==1&& account.setAuth==true">
                  <td colspan="15">
                        <div class="d-flex justify-content">
                          <button class="normalBtn" v-for="(product,index) in products" :key="index" @click="setProduct(account.objectId,product.objectId)">{{ product.name }}</button>
                        </div>

                        <div class="d-flex justify-content mt-2">
                          免费赠送<input type="text" style="width:30px" v-model="free_days">天
                          <button class="normalBtn" @click="setFreeDays(account.objectId)">赠送</button>
                         
                        </div>

                    </td>

                </tr>
                </template>
                  
                </table>
              <div class="full-width" style="border-bottom: 1px solid black;margin-bottom: 20px;"  v-if="group.name!='' &&group.accounts.length>0"></div>
              </template>
            </div>
            <div v-else class="secondColor">暂无账号</div>
        </div>

        <div class="mt-1 mb-1 d-flex justify-content" v-if="totalPage>1">

          <div v-for="(n,index) in totalPage" :key="index">
            <div :class="n==page+1?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n)">
              {{ n }}
            </div>
            
          </div>

        </div>

      </div>
        <div>
        </div>
      </div>
  
  
      <div>

            <PopupWindow v-model:isShow="showPopup">

            <XHSQR v-model:passedAccount="selectedAccount" @qr_generated="set_selected" @login_suc="xhsLogined"></XHSQR>
            </PopupWindow>  

</div>
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';
  import PopupWindow from '@/components/PopupWindow.vue';
  import moment from 'moment';
  import XHSQR from '@/components/XHSQR.vue';
  
  export default {
    data(){
      
      return {
        users:[],
        isLoading:false,
        ifAdd:false,
        code_sent:false,
        count:180,
        timer:null,
        showPopup: false,
        selectedAccount:null,
        showContentPop:false,
        isValid: true,
        spinnerColor:"#262626",
        errors:'',
        qr_interval:null,
        logined:false,
        totalPage:0,
        perPage:10,
        page:0,
        admin_page:0,
        role:0,
        user_type:1,
        free_days:7,
        products:null
        
      }
      
    },
   
    components: {
      GridLoader,
      PopupWindow,
      XHSQR

    },
    computed: {
    countDown() {
      return `${this.count}秒`
    },
    localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD');
         return beijingTime
         
       }
     },
    formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     }
  },
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  
    beforeUnmount(){
      console.log(this.page)
      console.log(this.user_type)
       localStorage.setItem('useradmin_page',this.page)
       localStorage.setItem('useradmin_type',this.user_type)
  
        if(this.qr_interval!=null)
        {
          clearInterval(this.qr_interval)
        }
    },
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
      console.log(token)
       if(token==undefined || token==null ||token=='')
       {
          this.$router.push('index')
          return
       }
      
       console.log(this.page)

      this.user_type=localStorage.getItem('useradmin_type')
      console.log(this.user_type)
      if (this.user_type==undefined)
      {
        this.user_type=1
      }
      this.getCustomersCount()
      this.getProducts()
    
    },
    methods:{ 
      setAuth(account){
        if(account.setAuth==undefined ||account.setAuth==false)
      {
        account.setAuth=true
      }
      else
      {
        account.setAuth=false
      }
       
      },
    async setProduct(accountId, productId){
      if (window.confirm("确定要配置权限吗?")) {
      try{
          const response = await axios.get(this.domain+'xhs/set_auth?account_id='+accountId+'&product_id='+productId);
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            this.getCustomersCount()
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
       
        }

    },
    async setFreeDays(accountId){
      if (window.confirm("确定要赠送免费时长吗?")) {
      try{
          const response = await axios.get(this.domain+'xhs/add_free_days?account_id='+accountId+'&free_days='+this.free_days);
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            this.getCustomersCount()
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        
        }

    },

     async getProducts(){
        
        try{
          const response = await axios.get(this.domain+'xhs/get_products');
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            this.products=data.products
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
       
      },
   
      getXuanti(account_id){
        this.$router.push('/index/user/prexuanti/'+account_id)
      },

      setCookie(account_id){
        this.$router.push('/index/user/ck/'+account_id)
      },
      change_user_type(type){
        this.page=0
        this.user_type=type
        this.getCustomersCount();
      },
        showLoginPopup(account){
      
      this.selectedAccount=account;
      this.showPopup=true;

    },   
    async deleteAccount(user_index,account_id,ac_index,group_index){
      if (window.confirm("确定要删除吗?")) {

        this.isLoading=true
        try{
          const response = await axios.get(this.domain+'xhs/delete_account?account_id='+account_id);
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            console.log(this.users[user_index])
            this.users[user_index].groups[group_index].accounts.splice(ac_index,1)
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      }

    },

    async validAccount(account_id,user_index,ac_index,group_index){
      if (window.confirm("确定要激活此用户吗?")) {

        this.isLoading=true
        try{
          
          const response = await axios.get(this.domain+'xhs/valid_account?account_id='+account_id);
          var data=response.data
          var account=this.users[user_index].groups[group_index].accounts[ac_index]
          if(data.status=='Suc')
          {
            
            this.users[user_index].groups[group_index].accounts[ac_index]['valid']=!account['valid']
   
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      }

    },

     async fenghaoAccount(account_id,user_index,ac_index,group_index){
     

        this.isLoading=true
        try{
          
          const response = await axios.get(this.domain+'xhs/fenghao_account?account_id='+account_id);
          var data=response.data
          if(data.status=='Suc')
          {
            var account=this.users[user_index].groups[group_index].accounts[ac_index]
            if(account['fenghao']==true)
            {
                this.users[user_index].groups[group_index].accounts[ac_index]['fenghao']=false;  
            }
            else
            {
                this.users[user_index].groups[group_index].accounts[ac_index]['fenghao']=false;
            }
           
            
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      

    },
    

     async templateAccount(account_id,user_index,ac_index,group_index){
    
        this.isLoading=true
        try{
          
          const response = await axios.get(this.domain+'xhs/template_account?account_id='+account_id);
          var data=response.data
          if(data.status=='Suc')
          {
 
            var account=this.users[user_index].groups[group_index].accounts[ac_index]
            if(account['is_template']==true)
            {
                this.users[user_index].groups[group_index].accounts[ac_index]['is_template']=false;  
            }
            else
            {
                this.users[user_index].groups[group_index].accounts[ac_index]['is_template']=false;
            }
           
            
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      

    },

    async resetAccount(account_id){
      if (window.confirm("确定要重置选题吗?")) {

        this.isLoading=true
        try{
          const response = await axios.get(this.domain+'xhs/reset_xuanti?account_id='+account_id);
          var data=response.data
          if(data.status!='Suc')
          
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      }

    },

    async getCustomersCount(){
        this.isLoading=true
        try{
          var response=null;
          if(this.user_type==1)
          {
             response = await axios.get(this.domain+'xhs/get_customer_users_count');
          }
          else if(this.user_type==2)
          {
             response = await axios.get(this.domain+'xhs/get_admin_users_count');
          }
          
  
          var data=response.data

          if(data.status=='Suc')
          {
              var count=data.count
              this.totalPage=Math.ceil(count/this.perPage);
              if(this.user_type==1)
              {
                this.page=localStorage.getItem('useradmin_page')
              }
              else
              {
                this.page=0
              }
              
            if(this.page==undefined)
            {
              this.page=0
            }
              this.getUsers();
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }
     
       
       
      },
      changePage(n){
        this.page=n-1
        this.getUsers();

      },

       async getUsers(){
        this.isLoading=true
        try{
  
          var response=null;
          if(this.user_type==1)
          {
             response = await axios.get(this.domain+'xhs/get_users?page='+this.page+'&&count='+this.perPage);
          }
          else if(this.user_type==2)
          {
             response = await axios.get(this.domain+'xhs/get_admin_users?page='+this.page+'&&count='+this.perPage);
          }
          
  
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
              var results=data.users
              this.users=results;
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }
        finally
        {
          this.isLoading=false
        }
       
       
      },
  
   
      
    }
     
    
  };
  </script>
  <style scoped>
  
  .account_icon{
    width: 28px;
  height: 28px;
  border-radius: 28px;
  }
  
  .operationIcon{
    width:24px;
    height:24px;
    cursor:pointer
  }
  
  .textbox_label{
    align-self: stretch;
   color: #262626;
   font-family: "Alibaba PuHuiTi";
   font-size: 14px;
   font-style: normal;
   font-weight: 400;
   line-height: normal;
  }
  .textBox{
    width:300px;
  }
  
  .dropdown{
    width: 130px;
  }
  
  .submitBtn{
  
   width: 300px;
  }
  
  .error-message{
    color:red
  }

  .template{
    font-weight: bold;
    color:blue
  }

  .tencent{
    font-weight: bold;
    color:#5daa80;
  }
  .backBtn{
    font-size: 10px;
  }
  </style>
  
  
  